<mat-icon class="icon {{ iconClass }} {{ color }}" [style.font-size.px]="size">{{ iconName }}</mat-icon>
